module.exports = __webpack_public_path__ + "img/cloud.e31bf6c.svg";